export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/self_help_wellness.aa8452a.svg";